<template>
  <div>
    <v-card width="100%" height="42px" dark color="white" flat tile>
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12" md="8">
            <v-row>
              <v-col @click="goBack()" class="fake-link font-dm">
                <img :src="post.picture ? require('@/assets/arrow-left@1,5x.svg') : require('@/assets/arrow-left-purple.png')" width="16px" class="ml-5" />
              </v-col>
              <v-col class="text-right">
                <img
                  :src="post.picture ? require('@/assets/share.png') : require('@/assets/share@1,5x.svg')"
                  width="16px"
                  class="mr-5 fakeLink"
                  v-if="page && webShareApiSupported"
                  @click="shareViaWebShare"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card flat tile width="100%" min-height="80vh" :class="$vuetify.breakpoint.mdAndUp ? 'py-10' : 'py-2'">
      <v-container :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-10'">
        <v-row justify="center" align="center" class="my-0">
          <v-col cols="12" md="6" :class="$vuetify.breakpoint.mdAndUp ? 'py-0 my-0' : ''" order="4" order-md="2">
            <span class="post-category color-blue font-dm" v-if="$vuetify.breakpoint.mdAndUp">{{ translateCategory(post.category) }}</span>
            <span class="post-title color-purple font-dm">{{ post.title }}</span>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" md="6" class="py-0 my-0">
            <div class="text-center">
              <img :src="post.image" v-if="post.image" class="my-3 rounded-un quiz-image" />
            </div>

            <div v-if="post.description" v-html="post.description"></div>

            <div v-html="post.feedback_message"></div>

            <div v-if="post.url_button_text && post.joined">
              <v-btn dark color="#7D4CA8" class="rounded-un mb-5" block depressed x-large @click="goToLink(post.url)">
                Acesse o link da atividade
              </v-btn>
            </div>

            <div v-if="!post.joined">
              <div v-if="post.quiz_type === 'select'">
                <span class="subtitleQuiz"> Apenas uma resposta </span>
                <v-radio-group v-model="radioAnswer">
                  <v-radio v-for="(item, i) in post.answers" :key="i" :value="item.id" color="#FFFFFF">
                    <template v-slot:label="">
                      <img :src="item.image" v-if="item.image" height="48px" />
                      {{ item.answer }}
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-btn block large color="#FFFFFF" class="mt-2 rounded-un color-pink" @click="send()">Responder</v-btn>
              </div>

              <div v-if="post.quiz_type === 'buttons'">
                <v-row class="mt-2">
                  <v-col v-for="(item, i) in post.answers" :key="i">
                    <v-btn color="white" x-large block outlined class="rounded-un" @click="send(item.id)">{{ item.answer }}</v-btn>
                  </v-col>
                </v-row>
              </div>

              <div v-if="post.quiz_type === 'multiple'">
                <p class="subtitleQuiz mb-5">Múltiplas respostas</p>
                <v-row class="mb-5">
                  <v-col :cols="item.image ? '6' : '12'" v-for="(item, i) in post.answers" :key="i" :class="item.image ? 'text-center' : 'text-left py-0 my-0'">
                    <img :src="item.image" width="100%" v-if="item.image" @click="setAnswer(item.id)" :class="checkSelect(item.id) ? 'multiple-selected rounded-un pa-0' : 'rounded-un pa-0'" />
                    <span v-if="!item.image" @click="setAnswer(item.id)">
                      <v-checkbox v-model="checkbox[item.id]" :label="item.answer" hide-details class="my-0"></v-checkbox>
                    </span>
                  </v-col>
                </v-row>

                <v-btn block large color="#FFFFFF" class="mt-2 rounded-un color-purple" @click="send()">Responder</v-btn>
              </div>

              <div v-if="post.quiz_type === 'openfield'">
                <div class="quiz-openfield">
                  <div class="quiz-openfield-l">
                    <v-text-field hide-details outlined color="#ffffff" class="input-un-outlined" dark v-model="openfield" v-mask="post.mask" v-if="post.mask"></v-text-field>
                    <v-text-field hide-details outlined color="#ffffff" class="input-un-outlined" dark v-if="!post.mask" v-model="openfield"></v-text-field>
                  </div>
                  <div class="quiz-openfield-r">
                    <v-btn block depressed color="#FFFFFF" class="button-un-outlined color-purple" @click="send()">Enviar</v-btn>
                  </div>
                </div>
              </div>

              <div v-if="post.quiz_type === 'cityfield'">
                <v-select
                  filled
                  hide-details
                  outlined
                  background-color="#ffffff"
                  class="mt-2 mb-5 input-un rounded-un"
                  placeholder="Selecione"
                  light
                  :items="states"
                  item-text="nome"
                  item-value="sigla"
                  v-model="state"
                ></v-select>
                <v-text-field filled color="#ff55a6" hide-details outlined background-color="#ffffff" class="mt-2 mb-5 input-un rounded-un" light v-model="city"></v-text-field>

                <v-btn block large color="#FFFFFF" class="mt-2 rounded-un color-pink" @click="send(city + '/' + state)">Responder</v-btn>
              </div>

              <div v-if="post.quiz_type === 'download'">
                <v-btn dark color="#7D4CA8" class="rounded-un" block depressed x-large @click="goTo(post.fileDownload)" :disabled="post.joined">
                  <span v-if="post.button_text">{{ post.button_text }}</span>
                  <span v-if="!post.button_text">Download</span>
                </v-btn>
              </div>

              <div v-if="post.quiz_type === 'url'">
                <v-btn dark color="#7D4CA8" class="rounded-un" block depressed x-large @click="goTo(post.url)" :disabled="post.joined">
                  <span v-if="post.button_text">{{ post.button_text }}</span>
                  <span v-if="!post.button_text">Vamos Lá!</span>
                </v-btn>
              </div>

              <div v-if="post.quiz_type === 'form'">
                <v-form ref="form" v-model="form">
                  <p class="mt-2" v-if="post.answers">
                    Só pra confirmar, essas informações estão corretas? Não queremos errar seu nome! 😜
                  </p>
                  <p class="mt-2" v-if="!post.answers">
                    Hmm, tem algumas informações faltando! Você pode completar?
                  </p>

                  <div v-for="(item, i) in post.fields" :key="i">
                    <b class="mt-2">{{ item.title }} <sup v-if="item.required" class="color-pink">*</sup></b>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#f3eeee"
                      class="mt-2 mb-5 input-un rounded-un"
                      style="border: 1px solid #f3eeee !important"
                      light
                      v-model="answer[item.field_id]"
                      :rules="rules"
                      v-if="item.required && item.mask && item.title !== 'Estado '"
                      v-mask="item.mask"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#f3eeee"
                      class="mt-2 mb-5 input-un rounded-un"
                      light
                      v-model="answer[item.field_id]"
                      v-if="!item.required && item.mask && item.title !== 'Estado '"
                      v-mask="item.mask"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#f3eeee"
                      class="mt-2 mb-5 input-un rounded-un"
                      style="border: 1px solid #f3eeee !important"
                      light
                      v-model="answer[item.field_id]"
                      :rules="rules"
                      v-if="item.required && !item.mask && item.title !== 'Estado '"
                    ></v-text-field>
                    <v-text-field
                      filled
                      color="#ff55a6"
                      hide-details
                      outlined
                      dense
                      background-color="#f3eeee"
                      class="mt-2 mb-5 input-un rounded-un"
                      light
                      v-model="answer[item.field_id]"
                      v-if="!item.required && !item.mask && item.title !== 'Estado '"
                    ></v-text-field>

                    <v-select
                      filled
                      dense
                      outlined
                      color="#ff55a6"
                      background-color="#f3eeee"
                      class="my-2 input-un"
                      v-if="item.field_id === 'estado'"
                      :items="states"
                      item-text="titulo"
                      item-value="id"
                      v-model="answer[item.field_id]"
                      placeholder="Selecione"
                    ></v-select>
                  </div>
                </v-form>

                <v-btn dark color="#7D4CA8" class="rounded-un mt-2" block depressed large @click="questione()" :loading="loading">
                  <span v-if="post.button_text">{{ post.button_text }}</span>
                  <span v-if="!post.button_text">Enviar</span>
                </v-btn>
              </div>
            </div>

            <div v-if="post.joined">
              <v-btn dark color="#7D4CA8" class="rounded-un mt-2" block depressed large disabled>
                Dados cadastrados
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'

export default {
  directives: { mask },
  data: () => ({
    question: false,
    toggle_exclusive: 1,
    post: {},
    id: null,
    fav: false,
    page: true,
    model: 0,
    form: false,
    answer: {},
    feedbackPositivo: ['Maravilha!', 'Vamos te mostrar mais conteúdos assim!', 'Que bom que você gostou! <3', 'Anotado! :)'],
    feedbackNegativo: ['Entendido ;)', 'Vamos aprender com isso e melhorar :)', 'Ok, a gente não acerta sempre, né? E tá tudo bem!', 'Anotado! ;)'],
    feedbackSalved: ['Salvo pra você ler depois (mas vê se não esquece. :P)', 'Salvo pra você ler depois.'],
    feedbackShare: [
      'Valeu por compartilhar nossa plataforma. Fazer conexões é muito importante para nós.',
      'Estamos felizes por você nos conectar com mais pessoas. Valeu!',
      'Dica boa é dica compartilhada. Valeu!',
    ],
    feedbackInteractive: [
      'Ops! Você não disse se gostou do conteúdo. Reaja para avançar na sua jornada.',
      'O que achou desse conteúdo? Lembre de reagir pra avançar na sua jornada!',
      'Reaja aos conteúdos pra ir progredindo em sua jornada!',
      'Deixa eu te contar um segredo: você não precisa interagir com todos os nossos conteúdos para avançar de etapa, mas se você fizer isso, vai ganhar bônus. ;)',
    ],
    cta: null,
    rules: [(v) => !!v || 'Campo Obrigatório'],
    etapa: null,
    loading: false,
    resgate: false,
    download_question: false,
    states: [
      { titulo: 'Acre', id: 'AC' },
      { titulo: 'Alagoas', id: 'AL' },
      { titulo: 'Amapá', id: 'AP' },
      { titulo: 'Amazonas', id: 'AM' },
      { titulo: 'Bahia', id: 'BA' },
      { titulo: 'Ceará', id: 'CE' },
      { titulo: 'Distrito Federal', id: 'DF' },
      { titulo: 'Espírito Santo', id: 'ES' },
      { titulo: 'Goiás', id: 'GO' },
      { titulo: 'Maranhão', id: 'MA' },
      { titulo: 'Mato Grosso', id: 'MT' },
      { titulo: 'Mato Grosso do Sul', id: 'MS' },
      { titulo: 'Minas Gerais', id: 'MG' },
      { titulo: 'Pará', id: 'PA' },
      { titulo: 'Paraíba', id: 'PB' },
      { titulo: 'Paraná', id: 'PR' },
      { titulo: 'Pernambuco', id: 'PE' },
      { titulo: 'Piauí', id: 'PI' },
      { titulo: 'Rio de Janeiro', id: 'RJ' },
      { titulo: 'Rio Grande do Norte', id: 'RN' },
      { titulo: 'Rio Grande do Sul', id: 'RS' },
      { titulo: 'Rondônia', id: 'RO' },
      { titulo: 'Roraima', id: 'RR' },
      { titulo: 'Santa Catarina', id: 'SC' },
      { titulo: 'São Paulo', id: 'SP' },
      { titulo: 'Sergipe', id: 'SE' },
      { titulo: 'Tocantins', id: 'TO' },
    ],
  }),
  computed: {
    ...mapState(['option']),
    conteudo() {
      return encodeURIComponent(document.title + ' ' + window.location.href)
    },
    link() {
      return window.location.href
    },
    bgcolor() {
      if (this.post.category === 'ideias') {
        return '#e5f3fa'
      }
      if (this.post.category === 'acoes') {
        return '#e5efed'
      }
      if (this.post.category === 'quiz') {
        return '#ffeef6'
      }
      return ''
    },
    color() {
      if (this.post.category === 'ideias') {
        return '#008FD2'
      }
      if (this.post.category === 'acoes') {
        return '#006653'
      }
      if (this.post.category === 'quiz') {
        return '#FF55A6'
      }

      return ''
    },
    icon() {
      if (this.post.category === 'ideias') {
        return 'lamp@1,5x.svg'
      }
      if (this.post.category === 'acoes') {
        return 'flash@1,5x.svg'
      }
      if (this.post.category === 'quiz') {
        return 'puzzle@1,5x.svg'
      }

      return ''
    },
    webShareApiSupported() {
      return navigator.share
    },
  },
  watch: {
    option() {
      if (this.question) {
        if (this.option === 0) {
          this.send()
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Valeu! Aproveite ;D',
            button: [{ text: 'Ok!' }],
          })
          this.$store.dispatch('setOptionInfo', null)
          this.question = false
          this.confirm = true
          this.checkMoreBonus()
        }
        if (this.option === 1) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Tranquilo. Se quiser resgatar depois é só voltar nas suas recompensas. :)',
            button: 'Vamos lá',
            route: '/jornada',
          })
          this.$store.dispatch('setOptionInfo', null)
          this.question = false
        }
      }
      if (this.confirm) {
        if (this.option === 0) {
          this.$store.dispatch('setOptionInfo', null)
          this.confirm = false
        }
      }
      if (this.download_question) {
        if (this.option === 0) {
          this.$store.dispatch('setOptionInfo', null)
          this.download_question = false
          this.checkMoreBonus()
        }
      }
    },
  },
  components: {
    // TheCta,
  },
  methods: {
    goTo(link) {
      let text = ''
      if (this.post.feedback_message) {
        text = this.post.feedback_message
      } else {
        if (this.post.quiz_type === 'download') {
          text = 'Pronto! O download já começou. Se não abrir automaticamente, vá até seus downloads, ele deve estar lá.'
        }
        if (this.post.quiz_type === 'url') {
          text =
            'Vamos te levar até outra página para mostrar conteúdos que também irão te ajudar nessa etapa. Parte da sua jornada acontece lá fora e é assim que ela fica ainda mais rica! Dá uma olhada lá e a gente te espera por aqui!'
        }
      }

      const qs = require('qs')
      const url = `${baseApiUrl}/answer`
      const object = {
        quiz_id: this.post.id,
        answer: true,
      }

      axios.post(url, qs.stringify(object)).then(() => {})

      window.open(link, '_BLANK')

      this.download_question = true

      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: text,
        button: [{ text: 'Vamos Lá' }],
      })
    },
    goToLink(link) {
      window.open(link, '_BLANK')
    },
    loadContent() {
      const url = `${baseApiUrl}/quiz/${this.id}/bonus`
      axios
        .get(url)
        .then((res) => {
          if (res.data.success === false) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: res.data.message,
              route: '/jornada',
            })
          }
          this.post = res.data
          if (this.post.quiz_type === 'form' && !this.post.joined) {
            for (let i = 0; i < this.post.fields.length; i++) {
              const element = this.post.fields[i]
              this.answer[element.field_id] = this.post.answers[element.field_id]
            }
          }
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
    loadSchools() {
      const url = `${baseApiUrl}/school_levels`
      axios
        .get(url)
        .then((res) => {
          this.schools = res.data
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
    renderYt(link) {
      const a = '' + link
      let finalLink = a.split('&')
      return finalLink[0].replace('watch?v=', 'embed/')
    },
    questione() {
      this.$refs.form.validate()
      if (!this.form) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Hmm, tem algumas informações faltando! Você pode completar?',
        })
        return
      }

      this.question = true
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: this.post.feedback_message,
        button: [{ text: 'Ok' }, { text: 'Ver depois', outlined: true }],
      })
    },
    send(value = null) {
      this.$refs.form.validate()
      if (!this.form) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Hmm, tem algumas informações faltando! Você pode completar?',
        })
        return false
      }
      this.loading = true
      const qs = require('qs')
      const url = `${baseApiUrl}/answer`
      const object = {
        quiz_id: this.post.id,
      }

      if (this.post.action_id) {
        object.action_id = this.post.action_id
      }

      if (this.post.quiz_type === 'select') {
        object.answer = this.radioAnswer
      }
      if (this.post.quiz_type === 'multiple') {
        object.answer = this.multipleAnswers
      }
      if (this.post.quiz_type === 'openfield' || this.post.quiz_type === 'date' || this.post.quiz_type === 'year' || this.post.quiz_type === 'checkuserdata') {
        object.answer = this.openfield

        if (this.post.quiz_type === 'date') {
          const newBirth = this.openfield.split('/')
          object.answer = newBirth[2] + '-' + newBirth[1] + '-' + newBirth[0]
        }
      }
      if (this.post.quiz_type === 'form') {
        object.answer = []
        Object.keys(this.answer).forEach((key) => {
          object.answer[key] = this.answer[key]
        })

        object.joined = true
      }
      if (value) {
        object.answer = value
      }

      axios.post(url, qs.stringify(object)).then(() => {
        this.loading = false
        this.post.joined = true
      })
    },
    checkMoreBonus() {
      const url = `${baseApiUrl}/journey`
      axios.post(url).then((res) => {
        if (res.data.posts) {
          let text = 'Uhul! Esperamos que você tenha gostado, planejamos com carinho. <3'
          let route = '/'
          let button = 'Voltar para home'

          Object.keys(res.data.posts)
            .reverse()
            .forEach((key) => {
              const element = res.data.posts[key]
              if (this.checkBonus(element)) {
                text = 'Uhul! E tem mais coisas legais por vir. Você tem mais recompensa disponível, sabia? 😍'
                button = 'Vamos Lá!'
                route = `/jornada#${key}`
                return false
              }
            })

          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: text,
            button: button,
            route: route,
          })
        }
      })
    },
    checkBonus(el) {
      if (el.conclusionsTotal) {
        if (el.conclusionsTotalDone) {
          if (el.conclusionsTotal > el.conclusionsTotalDone) {
            return true
          }
        } else {
          return true
        }
      }
      if (el.bonusesTotal) {
        if (el.bonusesTotalDone) {
          if (el.bonusesTotal > el.bonusesTotalDone) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },
    shareViaWebShare() {
      localStorage.removeItem('reactPost')
      window.open(
        'https://wa.me/?text=%2aConecta%20Meu%20Futuro%2e%2a%20Uma%20plataforma%20que%20vai%20te%20conectar%20ou%20reconectar%20com%20a%20sua%20jornada%20universitária%2E%20Embarca%20nessa%20jornada%20com%20a%20gente%3A%20unisinos%2Ebr%2fconectameufuturo',
        '_BLANK'
      )

      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: this.feedbackShare[Math.floor(Math.random() * this.feedbackShare.length)],
      })
    },
    goBack() {
      window.history.back()
    },
    translateCategory(category) {
      if (this.post.category === 'ideias') {
        return 'Ideias'
      }
      if (this.post.category === 'acoes') {
        return 'Ações'
      }
      if (this.post.category === 'quiz') {
        return 'Quiz'
      }
      if (this.post.category === 'regras') {
        return 'Sobre'
      }
      if (this.post.category === 'bonus') {
        return 'Bônus'
      }
      if (this.post.category === 'recompensa') {
        return 'Recompensa'
      }

      return category
    },
  },
  created() {
    window.scrollTo(0, 0)
    this.id = this.$route.params.id
    this.loadContent()
  },
  mounted() {
    localStorage.removeItem('salveProfile')
  },
}
</script>

<style>
.back-link {
  color: #ffffff !important;
  font-size: 23px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}
.title-post-mobile {
  font-size: 30px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 39px !important;
}

.rounded-left {
  -webkit-border-top-left-radius: 5px;
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-radius-topleft: 5px;
  -moz-border-radius-bottomleft: 5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.rounded-right {
  -webkit-border-top-right-radius: 5px;
  -webkit-border-bottom-right-radius: 5px;
  -moz-border-radius-topright: 5px;
  -moz-border-radius-bottomright: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

iframe {
  width: 100% !important;
}

.thepost img {
  max-width: 100% !important;
  height: auto !important;
}

.border-cicle {
  background: white;
  border: 1px solid grey !important;
  border-color: grey !important;
}

.instagram * {
  /* min-width: 320px !important; */
}
</style>
